import { render, staticRenderFns } from "./GalleryThumbnail.vue?vue&type=template&id=38ae21ca&scoped=true&"
import script from "./GalleryThumbnail.vue?vue&type=script&lang=js&"
export * from "./GalleryThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./GalleryThumbnail.vue?vue&type=style&index=0&id=38ae21ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ae21ca",
  null
  
)

export default component.exports